import { Box, Tab, Tabs, makeStyles, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import artifact from "../../../static/svgs/artifact.svg";
import badgeCheck from "../../../static/svgs/badge-check.svg";
import trophy from "../../../static/svgs/trophy.svg";
import React, { useEffect } from "react";

//Utils
import { capitalizeFirstLetter } from "utils/componentUtils";

//Assets
import skillsIcon from "static/svgs/artifact.svg";
import evidencesIcon from "static/svgs/badge-check.svg";
import dashboardIcon from "static/svgs/home.svg";
import activitiesIcon from "static/svgs/trophy.svg";
import { useSelector } from "react-redux";

export type NavigationTag = "home" | "activities" | "skills" | "artifacts";
const Navigation = ({
  handleNavigate,
}: {
  handleNavigate: (id: "activities" | "skills" | "artifacts") => void;
}) => {
  const { role } = useSelector((state: any) => state.account);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  
  let user = sessionStorage.getItem("userId");

  const links: { tag: NavigationTag; icon: any }[] =
    (role === "ROLE_EDUCATOR" && !user)
      ? [
          { tag: "home", icon: trophy },
          { tag: "skills", icon: trophy }
        ]
      : [
          { tag: "home", icon: trophy },
          { tag: "activities", icon: trophy },
          { tag: "artifacts", icon: artifact },
          { tag: "skills", icon: badgeCheck },
        ];

  useEffect(() => {
    const currentHash = location.hash.slice(1);
    const activeIndex = links.findIndex((link) => link.tag === currentHash);
    setValue(activeIndex === -1 ? 0 : activeIndex);
  }, [location.hash]);

  const [value, setValue] = React.useState(0);

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const newHash = `#${links[newValue].tag}`;
    navigate(newHash);
    document
      .getElementById(links[newValue].tag)
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.white,
        position: "relative",
        display: "flex",
        height: "62px",
      }}
    >
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            height: "62px",
            pt: "10px",
            "& .MuiTab-root": {
              color: "black",
              fontWeight: 500,
              "&.Mui-selected": { color: "black", fontWeight: 600 },
            },
          }}
          TabIndicatorProps={{
            sx: { backgroundColor: 'rgba(7, 27, 34, 1)', height: '3px', borderRadius:'4px' }, // Custom indicator color and height
          }}
        >
          {links.map((link, index) => {
            const labelMap: Record<NavigationTag, string> = {
              home: "Home",
              activities: "Activities",
              skills: role === "ROLE_EDUCATOR" && !user ? "Skill Planning Library" : "Skills",
              artifacts: "Artifacts",
            };

            return <Tab key={link.tag} label={labelMap[link.tag]} />;
          })}
        </Tabs>
      </Box>
    </Box>
  );
};

export default Navigation;
